import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const ContactUs = () => {
  return (
    <div>
        <Header/>
   
    <div className="bg-[#0F2C3E] text-white min-h-screen">
      {/* 🌟 1. Header Section */}
      <motion.div 
        initial={{ opacity: 0, y: -50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1 }} 
        className="text-center py-16"
      >
        <h1 className="text-4xl font-bold">Contact Shri Radha Krishna Mandir</h1>
        <p className="text-gray-300 mt-4">Feel free to reach out for any inquiries or visits.</p>
      </motion.div>

      {/* 📍 2. Contact Details */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 1, delay: 0.5 }} 
        className="grid grid-cols-1 md:grid-cols-3 gap-8 px-6 max-w-4xl mx-auto"
      >
        <div className="flex flex-col items-center text-center bg-[#1A3B4E] p-6 rounded-lg shadow-lg">
          <FaMapMarkerAlt className="text-purple-500 text-4xl mb-3" />
          <h3 className="text-xl font-semibold">Address</h3>
          <p className="text-gray-300">Sitabuldi, Nagpur, India</p>
        </div>

        <div className="flex flex-col items-center text-center bg-[#1A3B4E] p-6 rounded-lg shadow-lg">
          <FaPhoneAlt className="text-purple-500 text-4xl mb-3" />
          <h3 className="text-xl font-semibold">Phone</h3>
          <a href="https://wa.me/918087577777" target="_blank" rel="noopener noreferrer">
  <p className="text-gray-300">+91 8087577777</p>
</a>
        </div>

        <div className="flex flex-col items-center text-center bg-[#1A3B4E] p-6 rounded-lg shadow-lg">
          <FaEnvelope className="text-purple-500 text-4xl mb-3" />
          <h3 className="text-xl font-semibold">Email</h3>
          <p className="text-gray-300"> <a href="mailto:radheradhenagpur@gmail.com">radheradhenagpur@gmail.com</a></p>
        </div>
      </motion.div>

      {/* ✉️ 3. Contact Form */}
      <motion.form 
        initial={{ opacity: 0, y: 50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, delay: 1 }} 
        className="mt-16 bg-[#1A3B4E] p-8 rounded-lg shadow-lg w-full max-w-3xl mx-auto"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Send a Message</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input type="text" placeholder="Your Name" className="p-3 bg-gray-800 rounded-lg w-full text-white" required />
          <input type="email" placeholder="Your Email" className="p-3 bg-gray-800 rounded-lg w-full text-white" required />
        </div>

        <textarea placeholder="Your Message" className="p-3 bg-gray-800 rounded-lg w-full h-32 mt-4 text-white" required></textarea>

        <button 
          type="submit" 
          className="mt-6 w-full bg-purple-500 hover:bg-purple-600 text-white py-3 rounded-lg transition duration-300"
        >
          Send Message
        </button>
      </motion.form>

      {/* 📍 4. Location Map */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 1, delay: 1.5 }} 
        className="mt-16 w-full flex justify-center"
      >
        <iframe 
          className="w-full max-w-4xl h-64 rounded-lg shadow-lg" 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.8354345095834!2d-122.41941618468153!3d37.77492977975937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ2JzM5LjgiTiAxMjLCsDI1JzEwLjkiVw!5e0!3m2!1sen!2sus!4v1609802951987!5m2!1sen!2sus" 
          allowFullScreen 
          loading="lazy"
        ></iframe>
      </motion.div>
    </div>
    <Footer/>
    </div>
  );
};

export default ContactUs;
